import styled from '@emotion/styled/macro';
import { GridContainer, getSpace } from '../../../../../../../ui/index.ts';

export const Container = styled(GridContainer)`
  flex: 1;
  padding: ${getSpace('6')} ${getSpace('12')};
`;
